export const state = [
    { name:"Seleccionar" , value: 2 },
    { name: "Activo"     , value: 1 },
    { name: "No Activos" , value: 0 },
];

export const rate = [
    { name: "Seleccionar"        , value: 0 },
    { name: "Mayor a 1 estrella" , value: 1 },
    { name: "Mayor a 4 estrella" , value: 2 },
    { name: "Menor a 3 estrella" , value: 3 },
    { name: "Menor a 1 estrella" , value: 4 },
]
